export default "__VITE_ASSET__CHiQI4PY__"